import { render } from "./ContactHeader.vue?vue&type=template&id=00789086"
import script from "./ContactHeader.vue?vue&type=script&lang=js"
export * from "./ContactHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__